import type { PartnerTemplatePartner } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import type {
  EncounterKind,
  TemplateClassification,
} from '@/entities/templates';

// One card: a block note of any schema, a legacy protocol of a treatment
// schema, or a consultation schema without block notes.
export type GalleryItem = {
  id: string;
  kind: EncounterKind;
  name: string;
  schemaId: string;
  // A block note is filled from the dictation: live in a treatment encounter,
  // after the whole recording in a consultation. Other protocols and summaries
  // are generated after the recording.
  blockNote: boolean;
  // The treatment schemas that link a protocol; shown under its name.
  schemaNames: string[];
  savedByClinic?: boolean;
  description?: string | null;
  // Where the card's template sits in the catalog taxonomy; the list filters
  // by it.
  classification?: TemplateClassification;
  // Set when the card's template was converted from this partner's template.
  partner?: PartnerTemplatePartner;
  // The encounter starts with this protocol or note; one linked on demand is
  // selected, one linked always is part of every encounter of the schema.
  templateSeriesId?: string;
  onDemand: boolean;
};

export enum RecordingStep {
  Initial = 'initial',
  Settings = 'settings',
  Configure = 'configure',
  Recording = 'recording',
}
